import { thresholdOn } from './thresholds';
import type { ThresholdEntry } from './types';

export const PLAUSIBLE_MAX_HR = { min: 120, max: 220 } as const;

export interface RideMaxHr {
  activityId: string;
  name: string;
  localDate: string;
  maxHr: number;
}

export interface MaxHrStep {
  activityId: string;
  name: string;
  localDate: string;
  value: number;
}

const plausible = (bpm: number): boolean => bpm >= PLAUSIBLE_MAX_HR.min && bpm <= PLAUSIBLE_MAX_HR.max;

// Rides oldest first. A step beats every earlier plausible ride and the entry in effect on its date. A date that already
// starts an entry is skipped (accepting it would clash), and a day with two record rides keeps the higher one.
export function maxHrSteps(rides: readonly RideMaxHr[], history: readonly ThresholdEntry[]): MaxHrStep[] {
  const steps: MaxHrStep[] = [];
  let best = 0;
  for (const ride of rides) {
    if (!plausible(ride.maxHr) || ride.maxHr <= best) continue;
    best = ride.maxHr;
    const inEffect = thresholdOn(history, ride.localDate);
    if (inEffect !== null && (ride.maxHr <= inEffect.value || inEffect.effectiveFrom === ride.localDate)) continue;
    if (steps.at(-1)?.localDate === ride.localDate) steps.pop();
    steps.push({ activityId: ride.activityId, name: ride.name, localDate: ride.localDate, value: ride.maxHr });
  }
  return steps;
}
